(() => {
  const page = document.querySelector('.editorial-page--about, .editorial-page--cultural-research');
  if (!page) return;
  const mobile = matchMedia('(max-width: 749px)');
  const items = new Map();
  let active = null;

  function collapse() {
    if (!active) return;
    active.classList.remove('is-expanded');
    items.get(active)?.setAttribute('aria-expanded', 'false');
    active = null;
  }

  function sync() {
    collapse();
    for (const [container, button] of items) {
      button.remove();
      container.classList.remove('editorial-tap-image');
    }
    items.clear();
    if (!mobile.matches) return;
    page.querySelectorAll('#LandingMain .editorial-artwork, #LandingMain .process-section--editorial .process-video').forEach(container => {
      const surface = container.querySelector('.editorial-artwork__media') || container;
      const image = surface.querySelector('.landing-media img');
      if (!image || surface.querySelector('video, a, button')) return;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'editorial-image-toggle';
      button.setAttribute('aria-label', image.alt ? `Enlarge image: ${image.alt}` : 'Enlarge image');
      button.setAttribute('aria-expanded', 'false');
      button.addEventListener('click', () => {
        const wasActive = active === container;
        collapse();
        if (wasActive) return;
        active = container;
        container.classList.add('is-expanded');
        button.setAttribute('aria-expanded', 'true');
      });
      container.classList.add('editorial-tap-image');
      surface.append(button);
      items.set(container, button);
    });
  }

  document.addEventListener('click', event => {
    if (active && !items.get(active)?.contains(event.target)) collapse();
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') collapse();
  });
  mobile.addEventListener('change', sync);
  document.addEventListener('shopify:section:load', sync);
  document.addEventListener('shopify:section:unload', collapse);
  sync();
})();
